//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { venues_list } from '@/apis/stadium'
import { service_list, service_del } from '@/apis/product'
//import columns from './columns.js'
export default {
    data() {
        return {
            config: {
                //所屬場館
                gymnasiums: [],
            },
            form: {
                venueCode: "",
                type: "",
                typeCode: "",
                time: "",
                name: "",
                status: ""
            },
            //table loading
            loading: false,
            //table data
            data: [],
            //table columns
            columns: [],
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0
            }
        }
    },
    created() {
        this.columns = [
            { title: '產品名稱', dataIndex: 'name', key: 'name', width: 330, },
            { title: '產品類型', dataIndex: 'typeCode', key: 'typeCode', width: 220, scopedSlots: { customRender: 'typeCode' }, },
            { title: '所屬場館', dataIndex: 'venuesList', key: 'venuesList', width: 280, scopedSlots: { customRender: 'venuesList' }, },
            { title: '封面圖', dataIndex: 'mainImage', key: 'mainImage', width: 220, scopedSlots: { customRender: 'mainImage' }, },
            //{ title: '熱門產品', dataIndex: 'isPopular', key: 'isPopular', width: 100, scopedSlots: { customRender: 'isPopular' }, },
            { title: '推薦產品', dataIndex: 'isFeatured', key: 'isFeatured', width: 100, scopedSlots: { customRender: 'isFeatured' }, },
            //{ title: '主辦單位', dataIndex: 'organizer', key: 'organizer', width: 220, },
            //{ title: '報名人數', dataIndex: 'registeredParticipants', key: 'registeredParticipants', width: 220, },
            { title: '產品狀態', dataIndex: 'status', key: 'status', width: 100, scopedSlots: { customRender: 'status' }, },
            { title: '創建時間', dataIndex: 'createdTime', key: 'createdTime', width: 180, },
            { title: '操作', key: 'operation', width: 330, scopedSlots: { customRender: 'action' }, }
        ];
    },
    mounted() {
        this.$nextTick(async () => {
            await this.onPageConfig();
            await this.onPageLoad();
        });
    },
    methods: {
        async onPageConfig() {
            try {
                //加載所屬場館
                const res = await venues_list({ venueName: '', venueCode: '', venueState: '1', pageNumber: 1, pageSize: 999 });
                this.config.gymnasiums = res.data.records;

            } catch (error) {
                this.$message.error(error.message);
            }
        },
        async onPageLoad(isPostBack) {
            if (this.loading) return;
            if (!isPostBack) {
                this.pagination.current = 1;
            }
            try {
                this.loading = true;
                const res = await service_list({
                    ...this.form,
                    pageNumber: this.pagination.current,
                    pageSize: this.pagination.pageSize
                }) || {};
                if (res.code == 0) {
                    this.data = res.data.records;
                    this.pagination.total = res.data.total;
                } else {
                    if (res.msg)
                        throw new Error(res.msg);
                }
            } catch (error) {
                this.$message.error(error.message);
            } finally {
                this.loading = false;
            }
        },
        //獲取運動類型名稱
        getTypeCodeName(code) {
            switch (code) {
                case 'TENANT':
                    return '租場';
                case 'COURSE':
                    return '課程';
                case 'TEMP':
                    return '臨打';
                case 'ACTIVITY':
                    return '活動';
                case 'MATCH':
                    return '比賽';
                default:
                    return code;
            }
        },
        getTypeCodeColor(code) {
            switch (code) {
                case 'TENANT':
                    return 'orange';
                case 'COURSE':
                    return 'pink';
                case 'TEMP':
                    return 'orange';
                case 'ACTIVITY':
                    return 'red';
                case 'MATCH':
                    return 'purple';
                default:
                    return '';
            }
        },
        //頁面事件
        handleTableChange(pagination, filters, sorter) {
            this.pagination.current = pagination.current;
            this.onPageLoad(true);
        },
        //搜尋表單提交
        handleSearchSubmit(e) {
            e.preventDefault();
            this.onPageLoad(true);
        },
        //狀態更新
        async handleOnEditState(item, status) {
            //edit state
            try {
                const res = await venues_changeState(item.id, status);
                if (res.code == 0) {
                    this.onPageLoad(true);
                } else {
                    this.$message.error(res.msg);
                }
            } catch (error) {
                this.$message.error(error.message);
            }
        },
        //刪除行
        async handleOnDelete(item) {
            try {
                const res = await service_del(item.id);
                if (res.code == 0) {
                    this.onPageLoad(true);
                } else {
                    this.$message.error(res.msg);
                }
            } catch (error) {
                console.log('delete error', error);
            }
        },
        handleToDetails(id) {
            this.$router.push(`/product/${id}`);
        },
        handleToForm(id) {
            if (id) {
                this.$router.push(`/product/form/${id}`);
            } else {
                this.$router.push(`/product/form`);
            }

        }
    }
}
